import React from "react";
import {Box, ButtonBase, IconButton, Paper, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {CallEnd01Icon, Mic01Icon, MicOff01Icon} from "@hugeicons/core-free-icons";
import {useWebrtc} from "../../context/WebrtcContext";
import {CallTimer, isCallLive, roundSx} from "./ActiveCallCard";

// The phone minimized during a live call: who and how long, with mute and hang up. Click it to open the phone again.
export const MiniCallBar = ({onExpand}) => {
  const {call, hangup, toggleMute} = useWebrtc();
  if (!isCallLive(call)) return null;

  return (
    <Paper elevation={0} sx={{
      position: "fixed", right: 28, bottom: 28, zIndex: 1200, display: "flex", alignItems: "center", gap: 0.5,
      pl: 0.5, pr: 1, height: 56, borderRadius: "999px", bgcolor: "#fff", boxShadow: "0 12px 32px rgba(35, 38, 77, 0.18)",
    }}>
      <ButtonBase onClick={onExpand} aria-label={"Open the phone"} sx={{
        display: "flex", alignItems: "center", gap: 1.25, height: 44, pl: 1.5, pr: 1.5, borderRadius: "999px", textAlign: "left",
        "&:hover": {bgcolor: "#FAFAFD"},
      }}>
        <Box sx={{width: 8, height: 8, borderRadius: "50%", bgcolor: "#22C55E", flexShrink: 0}}/>
        <Box sx={{minWidth: 0, maxWidth: 150}}>
          <Typography noWrap sx={{fontSize: 13, fontWeight: 700, color: "#23264D", lineHeight: 1.2}}>{call.caller}</Typography>
          <Typography sx={{fontSize: 12, color: "#1E8A55", fontVariantNumeric: "tabular-nums", lineHeight: 1.2}}>
            On a call · <CallTimer startedAt={call.startedAt}/>
          </Typography>
        </Box>
      </ButtonBase>
      <Tooltip title={call.muted ? "Unmute" : "Mute"}>
        <IconButton onClick={toggleMute} aria-label={call.muted ? "Unmute" : "Mute"}
                    sx={call.muted ? roundSx("#23264D", "#fff", 40) : roundSx("#F2F2F7", "#23264D", 40)}>
          <HugeiconsIcon icon={call.muted ? MicOff01Icon : Mic01Icon} size={18}/>
        </IconButton>
      </Tooltip>
      <Tooltip title={"Hang up"}>
        <IconButton onClick={hangup} aria-label={"Hang up"} sx={roundSx("#E5484D", "#fff", 40)}>
          <HugeiconsIcon icon={CallEnd01Icon} size={18}/>
        </IconButton>
      </Tooltip>
    </Paper>
  );
};
